// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3W3TR","content":"RecentSearches_content__2Ukob"};